"use client";
import React, { useEffect, useState } from "react";
import productData from "../../data/Product.json";
import VenteFlashProduct from "../cards/VenteFlashProduct";
import { fetchProductImages, fetchProductText, productList } from "../../data/Productlist";
import Loading from "../../utils/Loading";


const VenteFlash = () => {
  const [dataSourceProd, setDataSourceProd] = useState<any[]>([]);
  const [isOpenProduct, setisOpenProduct] = useState(true);
  const [isLoadingText, setIsLoadingText] = useState(true);
  const [isLoadingImages, setIsLoadingImages] = useState(true);

  const fetchData = async () => {
    try {
      // Fetch text data first
      const products = await fetchProductText();

      // Set text data first (without images)
      setDataSourceProd(products);
      setisOpenProduct(false);
      setIsLoadingText(false);

      // Fetch images for the products after the text data is loaded
      const productsWithImages = await fetchProductImages(products);

      // Set the updated products with images
      setDataSourceProd(productsWithImages);

      setIsLoadingImages(false); // Images data loaded
    } catch (error) {
      console.error("Failed to fetch products: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <section className="banner-block pb-10">
        <div className="w-[95%] m-auto">
          <div className="fx-reveal flex justify-between items-center pb-2 relative border-b border-line line-bottom mb-4">
            <h3 className="text-orange font-bold uppercase">NOUVEAUTÉS</h3>
            <a href="/shop" className="text-secondary max-sm:hidden">
              Voir tous les produits
            </a>
          </div>
          {
            isOpenProduct && <Loading />
          }
          <div className="flex max-sm:hidden flex-wrap gap-5 max-sm:justify-center">
            {dataSourceProd?.slice(0, 5).map((product, index) => (
              <VenteFlashProduct key={index} data={product} />
            ))}
          </div>
          <div className="hidden flex-wrap gap-5 max-sm:flex max-sm:justify-center">
            {dataSourceProd?.slice(0, 6).map((product, index) => (
              <VenteFlashProduct key={index} data={product} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default VenteFlash;
